module.exports = __webpack_public_path__ + "img/AdobeStock_116148078.7e20b6fb.jpeg";